import React, { useState } from 'react'
import Navbar from '../../components/navbar_poc'
import { Link } from 'react-router-dom'
import { useParams } from 'react-router-dom';
import bg1 from '../../assets/images/single_case.jpg'
import client from '../../assets/images/client/05.jpg'
import Shape from '../../components/shape'
import ShapeTwo from '../../components/shape-two'
import Footer from '../../components/footer'
import { services_india_evaluation, services_india_entry, services_india_growth  } from '../../data'
import {FiArrowRightCircle} from '../../assets/icons/vander'
export default function PageServiceSingle() {
    const { id } = useParams();
    const allServices = [
        ...services_india_evaluation,
        ...services_india_entry,
        ...services_india_growth
      ];
    const study = allServices.find((s) => s.id === id);
    let [activeTab, setActiveTab] = useState(1)
  return (
    <>
    <Navbar navLight={true}/> 

    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="container">
          <div className="row position-relative align-items-center pt-4">
              <div className="col-lg-6">
                  <div className="title-heading p-4 rounded bg-white shadow mt-4">
                      <span className="badge bg-primary rounded-pill"> Services </span>
                      <h2 className="mt-3">{study.title}</h2>
                      <p className="para-desc text-muted">{study.shortDescription}</p>
                      <div className="mt-4">
                          <div className="d-flex">
                              <img src={client} className="img-fluid avatar avatar-small rounded-pill me-3 shadow" alt=""/>
                              <div className="author mt-3">
                                  <h5 className="mb-0"><Link to="#" className="text-dark name">{study.name}</Link></h5>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <ShapeTwo/>

    <section className="section">
      <div className="container">
          <div className="row">
              <div className="col-12">
                  <div className="casestudy">
                       <h4 className="mt-4"> Overview</h4>
                      <p className="text-muted">{study.overview}</p>
                  
                      <h4 className="mt-4">Key Offerings</h4>
                         <ul className="list-unstyled ps-0">
                            {study.offerings.map((el,index)=>{
                                return(
                                     <li className="feature-list h6 mb-1" key={index}><i className="text-success me-3"><FiArrowRightCircle/></i>{el}</li>
                                                                  )
                                    })}
                                </ul>
                      
                      <p className="text-muted description">{study.challenge}</p>                            

                      <h4 className="mt-4">Why It Matters</h4>
                      <p className="text-muted description">{study.whyItMatters}</p>

                      <h4 className="mt-4">Common Challenges We Solve</h4>
                      <ul className="list-unstyled ps-0">
                            {study.challenges.map((el,index)=>{
                                return(
                                     <li className="feature-list h6 mb-1" key={index}><i className="text-success me-3"><FiArrowRightCircle/></i>{el.problem}</li>                                                                 )
                                    })}
                                </ul>


                      <h4 className="mt-4">FAQs</h4>
                      
                            {study.faqs.map((faq,index)=>{
                                return(
                                    <div key={index}>
                                    <p className="font-semibold">Q: {faq.q}</p>
                                    <p className="ml-4">A: {faq.a}</p>
                                  </div>
                                      )})}
                               

  

     

                      <h4 className="mt-4">Related Services</h4>
                      <ul className="list-unstyled ps-0">
                            {study.relatedServices.map((el,index)=>{
                                return(
                                     <li className="feature-list h6 mb-1" key={index}><i className="text-success me-3"><FiArrowRightCircle/></i>{el}</li>                                                                 )
                                    })}
                                </ul>
                      {/* <ul className="list-unstyled ps-0">
                            {study.relatedServices.map((el,index)=>{
                                
                                return(
                                    
                                     <li  className="feature-list h6 mb-1" key={index}><i className="text-success me-3"><FiArrowRightCircle/></i><Link to={`/page-service-single/${el.id}`}  className="text-dark">{el}<i className="mdi mdi-chevron-right align-middle"></i></Link></li>                                                                 )
                                    })}
                                </ul> */}
                  </div>
              </div>
          </div>
      </div>
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
